<script lang="ts" setup>
defineProps<{
  icon: string
  title: string
  description: string
  href?: string
}>()
defineEmits<{ (e: 'click'): void }>()
</script>

<template>
  <NuxtLink :href="href" @click="$emit('click')">
    <div class="group p-4 flex items-center gap-4 cursor-pointer rounded hover:bg-hos-blue/20">
      <div class="size-14 shrink-0 bg-hos-blue grid place-content-center rounded-full">
        <Icon :name="icon" size="30px" class="text-white" />
      </div>
      <div>
        <h1 class="text-2xl font-semibold text-white group-hover:underline">
          {{ title }}
        </h1>
        <p class="text-lg text-hos-gray">
          {{ description }}
        </p>
      </div>
    </div>
  </NuxtLink>
</template>
